import { TourBuilderStoreEvents } from '../../events/TourBuilderStoreEvents';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { Scene, SceneGuid } from '../../types/Scene';
import { SceneLink, SceneLinkGuid } from '../../types/SceneLink';

export type DeleteSceneUseCase = {
  sceneGuid: SceneGuid;
  tourId: number;
};

export const deleteSceneUseCase = (
  params: DeleteSceneUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC,
  eventHandlers: TourBuilderStoreEvents
): Partial<TourBuilderStore> => {
  const store = getState();
  const sceneToDelete = store.scenes.get(params.sceneGuid);
  if (!sceneToDelete) {
    return store;
  }
  const newIds = store.scenesById.filter((guid) => guid !== params.sceneGuid);
  const newScenes = new Map<SceneGuid, Scene>(store.scenes);
  newScenes.delete(sceneToDelete.guid);

  const newLinks = new Map<SceneLinkGuid, SceneLink>(store.links);
  sceneToDelete.linkGuids.forEach((guid) => newLinks.delete(guid));

  eventHandlers.onSceneDeleted.notify({
    guid: params.sceneGuid,
  });

  // No need to await
  services.storageClient.deleteTourScene({
    tourId: params.tourId,
    tourSceneGuid: params.sceneGuid,
  });

  return {
    scenes: newScenes,
    scenesById: newIds,
    links: newLinks,
  };
};
